export const nav = [
  { label: "Accueil", href: "#accueil" },
  { label: "Services", href: "#services" },
  { label: "Réservation", href: "#reservation" },
  { label: "Rejoignez-nous", href: "#rejoignez-nous" },
  { label: "Contact", href: "#contact" },
];

export const socials = [
  {
    label: "Facebook",
    icon: "facebook",
    href: "https://www.facebook.com/evenement.tambour.oriental.zaffe.dabke.shamdabke?mibextid=wwXIfr&rdid=xreDEvHFs093giir&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17AupDpme5%2F%3Fmibextid%3DwwXIfr",
  },
  {
    label: "Instagram",
    icon: "instagram",
    href: "https://www.instagram.com/sham.dabke/?igsh=bGZ1c3U5ZTdnbGdh&utm_source=qr",
  },
  {
    label: "Snapchat",
    icon: "snapchat",
    href: "https://www.snapchat.com/@sham_dabke?invite_id=F8x4XpiC&locale=fr_FR&share_id=gQkURSX7R2CNxL61c9dMhQ&sid=017c44e1792442ee99b6bc116e6b4ba4",
  },
  {
    label: "TikTok",
    icon: "tiktok",
    href: "https://www.tiktok.com/@shamdabke?_t=ZN-8zzKPaEFjHS&_r=1",
  },
];

export const contactInfo = {
  phone: "06 49 41 73 30",
  phoneHref: "+33649417330",
  email: "contact@shamdabke.com",
  location: "Lyon, France",
  locationLong: "Lyon, France – déplacements dans toute la France et l’Europe proche",
};

export const heroSlides = [
  {
    image: "/img/carousel-1.jpg",
    eyebrow: "Bienvenue",
    title: "Troupe de dabké syrienne",
    text: "Sham Dabke, troupe professionnelle de danse et de percussions basée à Lyon, fait vibrer vos événements partout en France et en Europe.",
  },
  {
    image: "/img/carousel-2.jpg",
    eyebrow: "Patrimoine levantin",
    title: "Danse & percussions en live",
    text: "Chaque artiste est à la fois danseur(se) et percussionniste, pour une prestation dynamique, cohérente et pleine d’énergie.",
  },
];

export const aboutHighlights = [
  "Spectacles de dabké pour mariages, soirées privées et festivals.",
  "Ateliers et cours de dabké pour groupes, associations et entreprises.",
  "Interventions possibles dans toute la France et certains pays européens.",
];

export const services = [
  {
    image: "/img/service-1.jpg",
    title: "Mariages & soirées privées",
    text: "Entrées de mariés, shows de dabké, animations interactives avec les invités… Nous créons un moment fort et mémorable adapté à votre culture et à votre événement.",
  },
  {
    image: "/img/service-2.jpg",
    title: "Festivals & événements culturels",
    text: "Programmation culturelle, scènes ouvertes, événements associatifs ou municipaux : nous représentons le patrimoine levantin avec des chorégraphies originales et authentiques.",
  },
  {
    image: "/img/service-3.jpg",
    title: "Ateliers & cours de dabké",
    text: "Initiation ou perfectionnement à la dabké pour tous niveaux : associations, écoles, entreprises ou groupes d’amis. Une activité conviviale, sportive et culturelle à la fois.",
  },
];

export const eventTypes = [
  { value: "mariage", label: "Mariage" },
  { value: "soiree-privee", label: "Soirée privée" },
  { value: "festival", label: "Festival" },
  { value: "evenement-associatif", label: "Événement associatif" },
  { value: "entreprise", label: "Événement d’entreprise" },
  { value: "atelier", label: "Atelier / cours de dabké" },
  { value: "autre", label: "Autre" },
];

export const dabkeLevels = [
  { value: "debutant", label: "Débutant" },
  { value: "intermediaire", label: "Intermédiaire" },
  { value: "avance", label: "Avancé" },
  { value: "pro", label: "Professionnel" },
];

export const youtubeVideoId = "W-HqIX3-rJA";
